// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"fieldWrapper---ptQfH","itemBarcodeField":"itemBarcodeField---xevOB"};